import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Wrapper = styled.div(
  ({theme}) => css`
    display: grid;
    grid-template-rows: auto auto 1fr auto;
    min-height: 100vh;
    background: ${theme.colors.backgroundPrimary};
  `
);
